import {
  // CLEAR_VEHICULOS_ACTION,
  // FETCH_VEHICULOS,
  FETCH_VEHICULO_INFO,
  SEND_VEHICULO,
} from './actions.type';

import {
  SET_ERROR,
  CLEAR_ALERT_DIALOG,
  FETCHING_VEHICULO,
  FETCHED_VEHICULO,
  SUBMITED_VEHICULO,
  SUBMIT_VEHICULO_ERROR,
  RESET_VEHICULO_SUBMIT,
  RESET_VEHICULO_PROCESSING,
  STARTED_VEHICULO_PROCESSING,
  /*
  CLEAR_VEHICULOS,
  SET_VEHICULOS,
  FETCHED_VEHICULOS,
  FETCHING_VEHICULOS,
  CLEAR_VEHICULO_INFO,
  SET_VEHICULO,
  */
} from './mutations.type';
// eslint-disable-next-line import/no-cycle
import ApiService from '../common/api.service';

/* eslint-disable no-param-reassign */
/* eslint-disable no-shadow */

const state = {
  alert: false,
  alertMessage: '',
  alertType: 'success',
  alertDialog: false,
  alertDialogMessage: '',
  alertDialogType: 'success',
  submited_vehiculo: false,
  processing_vehiculo: false,
  loading_vehiculo: false,
  /*
  vehiculos_list: [],
  loading_vehiculos: false,
  vehiculo_info: {},
  */
};

const getters = {
  is_loading() {
    return state.loading_vehiculos;
  },
  vehiculo_submited() {
    return state.submited_vehiculo;
  },
  vehiculo_processing() {
    return state.processing_vehiculo;
  },
  /*
  vehiculos_list() {
    return state.vehiculos_list;
  },
  vehiculo_info() {
    return state.vehiculo_info;
  },
  */
  alertContainer(state) {
    return state.alert;
  },
  alertContainerMessage(state) {
    return state.alertMessage;
  },
  alertContainerType(state) {
    return state.alertType;
  },
  alertDialog(state) {
    return state.alertDialog;
  },
  alertDialogMessage(state) {
    return state.alertDialogMessage;
  },
  alertDialogType(state) {
    return state.alertDialogType;
  },
};

const actions = {
  [FETCH_VEHICULO_INFO](context, vehiculoId) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      context.commit(FETCHING_VEHICULO);
      // context.commit(CLEAR_VEHICULO_INFO);
      const url = `vehiculos/${vehiculoId}`;
      ApiService.query(url)
        .then(({ data }) => {
          // context.commit(SET_VEHICULO, data);
          context.commit(FETCHED_VEHICULO);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, [response.data.message]);
          context.commit(FETCHED_VEHICULO);
        });
    });
  },
  [SEND_VEHICULO](context, data) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      ApiService.upload('/vehiculos', data)
        .then(({ data }) => {
          context.commit(SUBMITED_VEHICULO, data);
          resolve(data);
          // context.dispatch(FETCH_VEHICULOS);
        })
        .catch(({ response }) => {
          context.commit(SUBMIT_VEHICULO_ERROR, [response.data.message]);
        });
    });
  },
  /*
  [FETCH_VEHICULOS](context) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      context.commit(FETCHING_VEHICULOS);
      ApiService.query('vehiculos')
        .then(({ data }) => {
          context.commit(SET_VEHICULOS, data);
          context.commit(FETCHED_VEHICULOS);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, [response.data.message]);
          context.commit(FETCHED_VEHICULOS);
        });
    });
  },
  [CLEAR_VEHICULOS_ACTION](context) {
    context.commit(CLEAR_VEHICULOS);
  },
  */
};

const mutations = {
  [SUBMITED_VEHICULO](state, data) {
    state.submited_vehiculo = true;
    state.alert = true;
    if (data.code !== 0) {
      state.alertType = 'error';
      state.alertMessage = data.message;
    } else {
      state.alertType = 'success';
      state.alertMessage = data.message;
    }
  },
  [SUBMIT_VEHICULO_ERROR](state, data) {
    state.alertDialog = true;
    state.alertDialogType = 'error';
    state.alertDialogMessage = data;
    state.processing_vehiculo = false;
  },
  [RESET_VEHICULO_SUBMIT](state) {
    state.alert = false;
    state.alertMessage = 'default';
    state.alertType = 'warning';
    state.submited_vehiculo = false;
  },
  [FETCHING_VEHICULO](state) {
    state.loading_vehiculo = true;
  },
  [FETCHED_VEHICULO](state) {
    state.loading_vehiculo = false;
  },
  [RESET_VEHICULO_PROCESSING](state) {
    state.processing_vehiculo = false;
  },
  [STARTED_VEHICULO_PROCESSING](state) {
    state.processing_vehiculo = true;
  },
  [CLEAR_ALERT_DIALOG](state) {
    state.alertDialog = false;
    state.alertDialogMessage = '';
    state.alertDialogType = 'success';
  },
  /*
  [CLEAR_VEHICULO_INFO](state) {
    state.vehiculo_info = {};
  },
  [CLEAR_VEHICULOS](state) {
    state.vehiculos_list = [];
  },
  [SET_VEHICULO](state, data) {
    state.vehiculo_info = data.vehiculo;
  },
  [SET_VEHICULOS](state, data) {
    state.vehiculos_list = data.vehiculos;
  },
  [FETCHING_VEHICULOS](state) {
    state.loading_vehiculos = true;
  },
  [FETCHED_VEHICULOS](state) {
    state.loading_vehiculos = false;
  },
  */
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
